import React from "react";
import "./../Homepage.css";
import "./weekly.css";

import 'react-slideshow-image/dist/styles.css';
import { Slide } from 'react-slideshow-image';

import boatSvg from "./../photos/vinyl-boat/boat-svg.webp";
import redBoatSvg from "./../photos/vinyl-boat/red-boat-svg.webp";
import whiteBoatSvg from "./../photos/vinyl-boat/white-boat-svg.webp";
import redVinyl from "./../photos/vinyl-boat/red-vinyl.webp";
import whitevinyl from "./../photos/vinyl-boat/white_vinyl.webp";
import redCutout from "./../photos/vinyl-boat/red-cutout.webp";
import whiteCutout from "./../photos/vinyl-boat/white-cutout.webp";
import bottle from "./../photos/vinyl-boat/bottle.webp";
import chamfer from "./../photos/laser-snake/chamfer.webp";
import constraints from "./../photos/laser-snake/constraints.webp";
import finalBody from "./../photos/laser-snake/finalBody.webp";
import finalBodyCAD from "./../photos/laser-snake/finalBodyCAD.webp";
import fullsnake from "./../photos/laser-snake/fullsnake.webp";
import headCAD from "./../photos/laser-snake/headCAD.webp";
import joint from "./../photos/laser-snake/joint.webp";
import jointBend from "./../photos/laser-snake/jointBend.webp";
import laser from "./../photos/laser-snake/laser.webp";
import loose from "./../photos/laser-snake/loose.webp";
import originalBody from "./../photos/laser-snake/originalBody.webp";
import sidebend from "./../photos/laser-snake/sidebend.webp";
import snakeHead from "./../photos/laser-snake/snakeHead.webp";
import snakeTail from "./../photos/laser-snake/snakeTail.webp";
import tailCAD from "./../photos/laser-snake/tailCAD.webp";
import upbend from "./../photos/laser-snake/upbend.webp";
const snakeSlide1 = [{image: finalBodyCAD, caption: "CAD for the new body piece"},
                     {image: finalBody, caption: "new body piece"},
                     {image: joint, caption: "snug joint connection"},
                     {image: jointBend, caption: "body piece flexing"},
                     {image: headCAD, caption: "CAD for the snake head"},
                     {image: tailCAD, caption: "CAD for the snake tail"}];
const snakeSlide2 = [{image: laser, caption: "Laser cutting all my pieces"},
                     {image: snakeHead, caption: "snake head"},
                     {image: snakeTail, caption: "snake tail"},
                     {image: fullsnake, caption: "full snake assembly"},
                     {image: sidebend, caption: "snake bending to the side"},
                     {image: upbend, caption: "snake bending up"}];

const Week2 = (props) => {
    return (
        <div className="HP-module">
        <div className="HP-subtitle">Week 2</div>
        <div className="HP-flex">
          <div className="HP-body HP-half">
            In the second week of the class we had several assignments. The first was to create this website (hi everybody). The next task was to get into the shop 
            for the first time and learn about vinyl cutting and laser cutting. I decided to attack the vinyl cutting first, since I had a sticker idea 
            in mind that I wanted to make for my water bottle. Keeping with my theme of boats, I set out to design and cut out a MIT sailboat. 
            I first worked on my 2D CAD skills to design a boat to my liking with Inkscape (pictured right). With my design complete, I needed to figure out how 
            to get my multi-color design out of the vinyl cutter. The first step I took was to create two new SVG files, one with just the red parts from the boat, 
            the other with the rest, which I'd color white. Now, with the two different parts of the boat mapped out, I loaded my SVG files one by one and 
            fed the right color vinyl into the cutter and made the parts of my boat. Here are some pictures of the vinyl after the print, both before and after removing 
            the excess vinyl around the cut.
          </div>
          <div className="HP-photoContent HP-half">
            <div className="HP-photoObject">
              <img src={boatSvg} className="HP-medPhoto" />
              <div className="HP-caption">The initial boat sticker design</div>
            </div>
            <div className="HP-flex">
              <div className="HP-photoObject">
                <img src={redBoatSvg} className="HP-scalePhoto" />
                <div className="HP-caption">The red part of the sticker</div>
              </div>
              <div className="HP-photoObject">
                <img src={whiteBoatSvg} className="HP-scalePhoto" />
                <div className="HP-caption">The white part of the sticker</div>
              </div>
            </div>
          </div>
        </div>
        <div className="HP-photoContainer">
          <div className="HP-photoObjectCenter">
            <img src={whitevinyl} className="HP-smallPhoto" />
          </div>
          <div className="HP-photoObjectCenter">
            <img src={redVinyl} className="HP-smallPhoto" />
          </div>
          <div className="HP-photoObjectCenter">
            <img src={whiteCutout} className="HP-smallPhoto" />
          </div>
          <div className="HP-photoObjectCenter">
            <img src={redCutout} className="HP-smallPhoto" />
          </div>
        </div>
        <div className="HP-body">
          Once the sticker was printed out and the excess vinyl was removed, all that was left was putting the sticker where it belonged, on my water bottle. 
          I transferred the sticker to some transfer paper to make it easier to keep track of the orientation and spacing of all the small pieces, and I applied 
          first the white and then the red cutouts of my boat sticker. Here is the final result.
        </div>
        <div className="HP-photoContainer">
            <img src={bottle} className="HP-medPhoto" />
        </div>
        <div className="HP-body">
          My next and final task for the week was to create a parametric design for a laser cut construction set that can be assembled in different ways. As I've 
          mentioned before, my CAD skills have a lot of room for improvement, so my goal for the project was to get a better understanding and more practice with 
          CAD sketches. In class we learned about the different types of joints that we could use for creating our pieces to fit together, and the most straightforward 
          of these pieces was the chamfer joint, a joint where the slot has a small bezel to get the parts lined up as they slide into place. Before I could start creating 
          my parts, however, our section as a group characterized some of the things about the laser cutter so we could appropriately cut. We determined through testing 
          on pieces of cardboard that the ideal settings to cut all the way through is 100% power, 15% speed, and 500 DPI. The laser also has a 0.11mm kerf and the joint clearance 
          in the test was 0.23". For cutting only part way through the carboard for flexing, you can increase the speed to {">"} 25%. Equipped with my laser knowledge, 
          I began CADing. <br /> <br />
        </div>
        <div className="HP-flex">
          <div className="HP-body HP-half">
            For my project I decided to build a snake out of a head, tail, and multiple body pieces with joints on both ends that could be put together to form a body of 
            arbitrary length. Further, I wanted to score the body pieces so that the snake could bend, making it more interesting to play with than just a rigid cardboard 
            body. First I made an initial design of the body piece, with no scoring, just to get the chamfers designed and the length about right. I designed this piece 
            (and all my pieces for this project) using parametric design: constraints on parts of the sketch to allow me to change the whole sketch with just a number 
            or two on a spreadsheet. Once I was satisfied with the size of the body piece, I added in the score lines, initially four across the mid section of the piece. 
            To test this initial design, I decided to cut two of them and see what it looked like in my hands. It turned out that the joint size was too large, and the pieces 
            didn't fit snugly together. I also realized that the orientation of the cardboard mattered for my goals, as cutting the scores along the corregation didn't affect 
            the rigidity of the piece much at all, but scoring in parallel with the corregation allowed the piece to bend a bit, which is the ultimate goal for the snake.
          </div>
          <div className="HP-photoContent HP-half">
            <div className="HP-photoObject">
              <img src={chamfer} className="HP-smallPhotoVert" />
              <div className="HP-caption">The first design of the chamfer body piece</div>
            </div>
            <div className="HP-photoObject">
              <img src={constraints} className="HP-smallPhotoVert" />
              <div className="HP-caption">The body piece with constraints visible</div>
            </div>
          </div>
        </div>
        <div className="HP-photoContainer">
          <div className="HP-photoObjectCenter">
            <img src={originalBody} className="HP-smallPhoto" />
          </div>
          <div className="HP-photoObjectCenter">
            <img src={loose} className="HP-smallPhoto" />
          </div>
        </div>
        <div className="HP-body">
          With this new information I went back to the drawing board and designed new pieces to test in the laser cutter. I used measuerments from my first failed test to realize 
          that my dimensions in FreeCAD, while proportional to the ones cut, were not the same, so I measured the oversized joint and used the proportion of free space to cardboard 
          to determine a new slot width for my joint. Additionally I designed a head and a tail for my snake, and added more scores to the body pieces for better flexibility.
           I then printed two more of the body pieces, and to my joy they came together snugly with a good fit. Below are some images of my designs on the CAD and the printed pieces.
        </div>
        <div className="HP-slide">
          <Slide>
              {snakeSlide1.map((image) => <div className="HP-slideDiv" key={image.caption}>
                  <div className="HP-photoObject">
                    <img src={image.image} className="HP-slidePhoto"/>
                    <div className="HP-caption">{image.caption}</div>
                  </div>
                </div>)}
            </Slide>
        </div>
        <div className="HP-body">
          Finally, I printed all the pieces for my snake. Knowing what I know now, and with my new and improved CAD skills, with extra 
          time I would have loved to make pieces with different designs, shapes, and bends for the body so that the snake could be more interesting than a straight line, and I would 
          have added even more score lines to improve the flexibility even further, but I am happy that I was able to build the first version of my cardboard snake. 
          Here are some photos of the completed snake
        </div>
        <div className="HP-slide">
          <Slide>
            {snakeSlide2.map((image) => <div className="HP-slideDiv" key={image.caption}>
                <div className="HP-photoObject">
                  <img src={image.image} className="HP-slidePhoto"/>
                  <div className="HP-caption">{image.caption}</div>
                </div>
              </div>)}
          </Slide>
        </div>
      </div>
    )
}

export default Week2;